import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import ProductKiezer from '../js/components/ProductKiezer';
import VerbruikSelection from '../js/components/VerbruikKiezer';
import VerbruikInput from '../js/components/WatIsJeVerbruik';
import AdresKiezer from '../js/components/AdresKiezer';
import ParticulierVerbruikEstimaterStep1 from '../js/components/VerbruikEstimater/Particulier/Step1';
import ParticulierVerbruikEstimaterStep2 from '../js/components/VerbruikEstimater/Particulier/Step2';
import ZakelijkeVragen from '../js/components/VerbruikEstimater/Zakelijk';
import EntiteitKiezer from '../js/components/EntiteitKiezer';
import PakketKiezer from '../js/components/PakketKiezer';
import TerugleveringInput from '../js/components/HoeveelStroomTerug';
import SelfStroomOpwekking from '../js/components/WekJeZelfStroomOp';
import PersoonsGegevens from '../js/components/PersoonsGegevens';
import ContactGegevens from '../js/components/ContactGegevens';
import BestellingOverzicht from '../js/components/BestellingOverzicht';
import BestellingAanmaken from '../js/components/BestellingAanmaken';
import ExtraOptions from '../js/components/ExtraOptions';
import ExplainerHeader from '../js/components/ExplainerHeader';
import Betrouwbaarheid from '../js/components/Betrouwbaarheid';
import MultipleEanSelection from '../js/components/MultipleEanSelection';
import StepperComponent from '../js/components/Stepper';
import { isRodaJCAction } from '../js/config/generalConfig';
// import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/style.css';
import CircularProgress from '@mui/material/CircularProgress'; // Import the CircularProgress component for the spinner
import { AgentConfig } from '../js/config/getAgentConfig';
import { Modal, Box } from '@mui/material';
import CustomPortal from '../js/components/CustomPortal/CustomPortal';

const App = ({ showAsModal }) => {
  const [agentConfig, setAgentConfig] = useState(null);
  const [configError, setConfigError] = useState(false); // New state for handling config errors

  useEffect(() => {
    const fetchData = async () => {
      setIsFetchingData(true); // Set fetching data to true
      const config = await AgentConfig.fetch(setIsFetchingData); // Use the static fetch method
      setIsFetchingData(false); // Set fetching data to false
      if (config) {
        setAgentConfig(config);
        setConfigError(false);
      } else {
        setConfigError(true);
      }
    };

    fetchData();
  }, []);

  function getAddressInformationFromLocalStorage() {
    var addressInformation = JSON.parse(localStorage.getItem('addressInformation'));
    if (addressInformation != null) {
      var postcode = addressInformation.postcode;
      var housenumber = addressInformation.housenumber;
      var housenumberSuffix = addressInformation.suffix === "Geen" || addressInformation.suffix === "" ? null : addressInformation.suffix;
      var business = addressInformation.business;
      var availableMeters = addressInformation.available_meters;
      var streetName = addressInformation.streetName;
      var cityName = addressInformation.city;
      var suffixList = addressInformation.suffixList;
    } else {
      var postcode = null;
      var housenumber = null;
      var housenumberSuffix = null;
      var business = null;
      var availableMeters = null;
      var streetName = null;
      var cityName = null;
      var suffixList = null;
    }
    return {
      postcode: postcode,
      housenumber: housenumber,
      housenumberSuffix: housenumberSuffix,
      business: business,
      available_meters: availableMeters,
      streetName: streetName,
      cityName: cityName,
      suffixList: suffixList
    }
  }

  const [currentStep, setCurrentStep] = useState(0);
  const [isFetchingData, setIsFetchingData] = useState(false); // State to keep track of when data is being fetched
  const [returnsEnergy, setReturnsEnergy] = useState(false); // We don't ask the user whether they return energy anymore, so set to false by default.
  const [returnedEnergyAmount, setReturnedEnergyAmount] = useState(null);
  const [postcode, setPostcode] = useState('');
  const [streetName, setStreetName] = useState('');
  const [cityName, setCityName] = useState('');
  const [housenumber, setHousenumber] = useState('');
  // Note that this state is only used to make sure that when the user navigates back to the AdresKiezer page,
  // that the housenumberSuffix field is still enabled. The value of this variable does not imply that the actual
  // address is valid, rather just the format of the fields.
  const [isPostCodeAndHouseNumberFormatValid, setIsPostCodeAndHouseNumberFormatValid] = useState(false);
  const [housenumberSuffix, setHousenumberSuffix] = useState('');
  const [selectedEan, setSelectedEan] = useState(null);
  const [housenumberSuffixList, setHousenumberSuffixList] = useState({});
  const [houseNumberSuffixesOnAddress, sethouseNumberSuffixesOnAddress] = useState({});
  const [verbruikEstimaterStep1Output, setVerbruikEstimaterStep1Output] = useState(null);
  const [verbruikEstimaterStep2Output, setVerbruikEstimaterStep2Output] = useState(null);
  const [verbruikEstimaterStep2BuildingType, setVerbruikEstimaterStep2BuildingType] = useState(null);
  const [finalChosenUsage, setFinalChosenUsage] = useState({
    e_single: null,
    e_high: null,
    e_low: null,
    gas: null
  });
  const [availableMeterTypes, setAvailableMeterTypes] = useState([]);
  const [multipleEanCodesForProducts, setMultipleEanCodesForProducts] = useState({});
  const [anyRelevantMultipleEanCodes, setAnyRelevantMultipleEanCodes] = useState(false);
  const [geslacht, setGeslacht] = useState('');
  const [voornaam, setVoornaam] = useState('');
  const [achternaam, setAchternaam] = useState('');
  const [geboorteDatum, setGeboorteDatum] = useState('');
  const [telefoonnummer, setTelefoonnummer] = useState('');
  const [email, setEmail] = useState('');
  const [chosenProduct, setChosenProduct] = useState([]);
  const [chosenPakket, setChosenPakket] = useState([]);
  const [entiteit, setEntiteit] = useState('');
  const [kvkNummer, setKvkNummer] = useState('');
  const [bedrijfsNaam, setBedrijfsnaam] = useState('');
  const [verbruikEstimaterRequired, setVerbruikEstimaterRequired] = useState(false);
  const [warmtepomp, setWarmtepomp] = useState(false);
  const [electricCarWithCharger, setElectricCarWithCharger] = useState(false);
  const [dubbeleMeter, setDubbeleMeter] = useState(false);
  const [termsOfServicesAccepted, setTermsOfServicesAccepted] = useState('');
  const [overstapDatum, setOverstapDatum] = useState('');
  const [betaalmethode, setBetaalmethode] = useState('');
  const [validationSucceeded, setValidationSucceeded] = useState([]);
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false);
  const [submissionFailed, setSubmissionFailed] = useState(false);
  const [submissionFailedWithReasons, setSubmissionFailedWithReasons] = useState(false);
  const [selectedBuildingType, setSelectedBuildingType] = useState(null);
  const [householdSize, setHouseholdSize] = useState(null);
  const [solarPanels, setSolarPanels] = useState(false);


  const [validationErrors, setValidationErrors] = useState({
    step0: [],
    step1: [],
    step2: [],
    step3: [],
    step4: [],
    step5: [],
    step6: [],
    step7: [],
    step8: [],
    step9: [],
    step10: [],
    step11: [],
    step12: [],
    step13: [],
    step14: [],
  });

  /**
   * Callback function to update the validationErrors state.
   * 
   * @param {*} step The step to update the validation errors for
   * @param {*} errors Contains the errors for the step. Can be a message string or an array. If an array, 
   * the first item in the array should be the message string and the second item should be a boolean to indicate whether
   * the message should be shown in the error box or not.
   */
  const handleValidationErrorsUpdate = (step, errors) => {
    // If there are errors, add them to the validationErrors state
    if (errors.length > 0) {
      setValidationErrors(prevErrors => ({
        ...prevErrors,
        [step]: [errors],
      }));
      // otherwise, remove the errors from the validationErrors state
    } else {
      setValidationErrors(prevErrors => ({
        ...prevErrors,
        [step]: [],
      }));
    }
  };


  const steps = {
    'Samenstellen': [0, 10],
    'Aanbieding': [11],
    'Gegevens': [12, 13],
    'Bestellen': [14],
    'Bedankt': [15],
  };





  /**
   * Returns the current group based on the current step.
   * @param {*} currentStep
   * @returns
   */
  const getCurrentGroup = (currentStep) => {
    return Object.keys(steps).find(group =>
      currentStep >= steps[group][0] && currentStep <= (steps[group][1] || steps[group][0])
    );
  };


  /**
   * Update the current group when the current step changes.
   */
  useEffect(() => {
    const newGroup = getCurrentGroup(currentStep);
    if (newGroup !== currentGroup) {
      setCurrentGroup(newGroup);
    }
  }, [currentStep]);


  /**
   * State to keep track of the current group.
   */
  const [currentGroup, setCurrentGroup] = useState(getCurrentGroup(currentStep));

  /**
   * Handle the group step click
   * @param {*} group
   */
  const handleGroupStepClick = (group) => {
    const groupIndex = Object.keys(steps).indexOf(group);
    const currentGroupIndex = Object.keys(steps).indexOf(currentGroup);

    if (groupIndex < currentGroupIndex) {
      const stepRange = steps[group];
      setCurrentStep(stepRange[0]);
      setCurrentGroup(group);
    }
  };




  const mapComponentsToSteps = {
    0: AdresKiezer,
    1: EntiteitKiezer,
    2: ProductKiezer,
    3: MultipleEanSelection,
    4: ExtraOptions,
    5: VerbruikSelection,
    6: ParticulierVerbruikEstimaterStep1,
    7: ParticulierVerbruikEstimaterStep2,
    8: VerbruikInput,
    9: SelfStroomOpwekking,
    10: TerugleveringInput,
    11: PakketKiezer,
    12: PersoonsGegevens,
    13: ContactGegevens,
    14: BestellingOverzicht,
  };

  const mapVariablesToComponents = {
    AdresKiezer: {
      postcode: postcode,
      housenumber: housenumber,
    },
    EntiteitKiezer: {
      entiteit: entiteit,
    },
    ProductKiezer: {
      chosenProduct: chosenProduct,
    },
    VerbruikSelection: {
      verbruikEstimaterRequired: verbruikEstimaterRequired,
    },

    MultipleEanSelection: {

    },

    ParticulierVerbruikEstimaterStep1: {
      verbruikEstimaterStep1Output: verbruikEstimaterStep1Output,
    },

    ParticulierVerbruikEstimaterStep2: {
      verbruikEstimaterStep2BuildingType: verbruikEstimaterStep2BuildingType,
    },

    VerbruikInput:  {
        finalChosenUsage: finalChosenUsage,
    },

    SelfStroomOpwekking: {
      returnsEnergy: returnsEnergy,
    },

    TerugleveringInput: {
      returnedEnergyAmount: returnedEnergyAmount,
    },

    PakketKiezer: {
    },

    ExtraOptions: {
      dubbeleMeter: dubbeleMeter,
    },

    PersoonsGegevens: {
      geslacht: geslacht,
      voornaam: voornaam,
      achternaam: achternaam,
      geboorteDatum: geboorteDatum,
      entiteit: entiteit
    },




    ContactGegevens: {
      telefoonnummer: telefoonnummer,
      email: email
    },

    BestellingOverzicht: {
      termsOfServicesAccepted: termsOfServicesAccepted,
    },

    BestellingAanmaken: {
      termsOfServicesAccepted: termsOfServicesAccepted,
    },

  };

  function getComponentVariables(displayName) {
    const componentVariables = mapVariablesToComponents[displayName];
    if (!componentVariables) {
      return {};
    }
    if (displayName == "VerbruikInput" && returnsEnergy) {
      componentVariables.returnedEnergyAmount = returnedEnergyAmount;
    }
    if (displayName == "VerbruikInput" && !dubbeleMeter) {
      //delete e_high and e_low from VerbruikInput.finalChosenUsage
      if ('e_high' in componentVariables.finalChosenUsage) {
        delete componentVariables.finalChosenUsage.e_high;
      }
      if ('e_low' in componentVariables.finalChosenUsage) {
        delete componentVariables.finalChosenUsage.e_low;
      }
    } else if (displayName == "VerbruikInput" && dubbeleMeter) {
      // delete e_single from VerbruikInput.finalChosenUsage. First check it exists (including if null)
      if ('e_single' in componentVariables.finalChosenUsage) {
        delete componentVariables.finalChosenUsage.e_single;
      }
    }
    // check if chosenProduct includes Gas. If not, remove gas key
    if (displayName == "VerbruikInput" && !chosenProduct.includes("Gas")) {
      if ('gas' in componentVariables.finalChosenUsage) {
        delete componentVariables.finalChosenUsage.gas;
      }
    }

    // Check if chosenProduct includes Electriciteit. If not, remove e_low, e_high, e_single
    if (displayName == "VerbruikInput" && !chosenProduct.includes("Electriciteit")) {
      if ('e_low' in componentVariables.finalChosenUsage) {
        delete componentVariables.finalChosenUsage.e_low;
      }
      if ('e_high' in componentVariables.finalChosenUsage) {
        delete componentVariables.finalChosenUsage.e_high;
      }
      if ('e_single' in componentVariables.finalChosenUsage) {
        delete componentVariables.finalChosenUsage.e_single;
      }
    }
    return componentVariables;
  }

  



  // Add KvK number and bedrijfsnaam to the mapVariablesToComponents object if the user is a business
  if (entiteit == "Zakelijk") {
    mapVariablesToComponents.PersoonsGegevens.kvkNummer = kvkNummer;
    mapVariablesToComponents.PersoonsGegevens.bedrijfsnaam = bedrijfsNaam;
  }

  if (multipleEanCodesForProducts) {
    // check if multipleEanCodesForProducts.GAS exists
    if (multipleEanCodesForProducts.GAS) {
      if (selectedEan && selectedEan.RequiredGasMeterEAN) {
        mapVariablesToComponents.MultipleEanSelection.RequiredGasMeterEAN = selectedEan.RequiredGasMeterEAN;
      } else {
        mapVariablesToComponents.MultipleEanSelection.RequiredGasMeterEAN = null;
      }
    }

    if (multipleEanCodesForProducts.ELK) {
      if (selectedEan && selectedEan.RequiredStroomMeterEAN) {
        mapVariablesToComponents.MultipleEanSelection.RequiredStroomMeterEAN = selectedEan.RequiredStroomMeterEAN;
      } else {
        mapVariablesToComponents.MultipleEanSelection.RequiredStroomMeterEAN = null;
      }
    }
  }


  const fieldToFriendlyNameMap = {
    'e_high': 'Wil je ook hoog opgeven? Indien geen, vul dan 0 in.',
    'e_low': 'Wil je ook laag opgeven? Indien geen, vul dan 0 in.',
    'e_single': 'Wil je ook je stroom opgeven? Indien geen, vul dan 0 in',
    'gas': 'Gelieve je gasverbruik in te vullen',
    'postcode': 'Gelieve je postcode in te vullen',
    'housenumber': 'Gelieve je huisnummer in te vullen',
    'finalChosenUsage': 'Gelieve je verbruik in te vullen',
    'chosenProduct': 'Gelieve je product in te vullen',
    'returnedEnergyAmount': 'Gelieve je teruggeleverde energie in te vullen',
    'returnsEnergy': 'Gelieve aan te geven of u zelf stroom opwekt',
    'return_high': 'Wil je ook teruglevering hoog opgeven? Indien geen, vul dan 0 in.',
    'return_low': 'Wil je ook teruglevering laag opgeven? Indien geen, vul dan 0 in.',
    'return': 'Wil je ook je teruglevering opgeven? Indien geen, vul dan 0 in.',
    'aanhef': 'Gelieve je aanhef in te vullen',
    'voornaam': 'Gelieve je voornaam in te vullen',
    'achternaam': 'Gelieve je achternaam in te vullen',
    'geboortedatum': 'Gelieve je geboortedatum in te vullen',
    'telefoonnummer': 'Gelieve je telefoonnummer in te vullen',
    'email': 'Gelieve je email in te vullen',
    'geslacht': 'Gelieve je aanhef in te vullen',
    'geboorteDatum': 'Gelieve je geboortedatum in te vullen',
    // 'slimmeMeter': 'Een slimme meter is verplicht',
    'termsOfServicesAccepted': 'Je moet de algemene voorwaarden accepteren voor je de bestelling kunt plaatsen',
    'bedrijfsnaam': 'Gelieve je bedrijfsnaam in te vullen',
    'kvkNummer': 'Gelieve je KvK nummer in te vullen',
    'selectedEan': 'Gelieve je EAN codes te selecteren. Kom je er niet uit? Neem dan contact op met onze klantenservice.',
    'RequiredGasMeterEAN': "Gelieve je gas EAN code te selecteren. Kom je er niet uit? Neem dan contact op met onze klantenservice.",
    'RequiredStroomMeterEAN': "Gelieve je stroom EAN code te selecteren. Kom je er niet uit? Neem dan contact op met onze klantenservice.",
  };

  if (!isRodaJCAction) {
        // add     'entiteit': 'Gelieve je entiteit in te vullen' to fieldToFriendlyNameMap
        fieldToFriendlyNameMap['entiteit'] = 'Gelieve je entiteit in te vullen';
  }




  /**
   *
   * @function getErrorMessageForComponent
   * @description Get the error message for a component
   * @param {*} component The component to get the error message for
   * @returns The error message for the component
   */
  function getErrorMessageForComponent(component) {
    let displayName = component.displayName;
    let variables = getComponentVariables(displayName);
    // if variables is a function, extract the variables

    let errorMessages = [];

    errorMessages.push(...validationErrors[`step${currentStep}`]);

    // Recursively validate nested objects. This is neccesary because some components have nested objects as props.
    // and we need to validate those as well.
    const validateFields = (obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (key == 'verbruikEstimaterStep1Output' && entiteit == "Zakelijk") {
          return;
        } else {
          if (value === '' || value === undefined || value === null) {
            let friendlyName = fieldToFriendlyNameMap[key] ? fieldToFriendlyNameMap[key] : key;
            // only push if the error message is not already in the array
            if (!errorMessages.includes(friendlyName)) {
              errorMessages.push(friendlyName);
            }
          } else if (typeof value === 'object') {
            // Recursively validate nested objects
            validateFields(value);
          } else {
            // remove friendly name from errorMessages if it exists
            let friendlyName = fieldToFriendlyNameMap[key] ? fieldToFriendlyNameMap[key] : key;
            errorMessages = errorMessages.filter(item => item !== friendlyName);

          }
        }
      });
    };

    validateFields(variables);

    return errorMessages;
  }



  /**
   * Get the address information from the local storage if it exists. Skip the first step if it does.
   */
  useEffect(() => {
    if (isRodaJCAction()) {
      setRodaJcSettings();
      // we skip the entiteit step if we are on the roda jc action
    } 
    const addressInformation = getAddressInformationFromLocalStorage();
    if (addressInformation.postcode != null) {
      setPostcode(addressInformation.postcode);
      setHousenumber(addressInformation.housenumber);
      setHousenumberSuffix(addressInformation.housenumberSuffix);
      setAvailableMeterTypes(addressInformation.available_meters ?? []);
      setStreetName(addressInformation.streetName);
      setCityName(addressInformation.cityName);
      sethouseNumberSuffixesOnAddress(addressInformation.suffixList ?? []);
      setHousenumberSuffixList(addressInformation ?? []);
      sendToDataLayer(0);
      if (isRodaJCAction()) {
        setRodaJcSettings();
        // we skip the entiteit step if we are on the roda jc action
        setCurrentStep(2);
      } else {
        setCurrentStep(1);
      }
    }
  }, []);


  /**
   * Validate the fields any of the fields change
   */
  useEffect(() => {
    validateFieldsNotEmpty();
  }, [postcode, housenumber, entiteit, chosenProduct, verbruikEstimaterRequired, verbruikEstimaterStep1Output, verbruikEstimaterStep2BuildingType, finalChosenUsage, termsOfServicesAccepted]);

 
  function setRodaJcSettings() {
    let isRodaJcActie = isRodaJCAction();
    // if this is the roda jc action, we need to set entiteit to 'Particulier'.
    // we also need to set bedrijfsnaam and kvkNummer to empty  strings.
    if (isRodaJcActie) {
      setEntiteit('Particulier');
      setBedrijfsnaam('');
      setKvkNummer('');
    }
  }


  /**
   * Validate the fields are not empty
   * @returns Object - Returns an object with the validation result and error messages
   */
  function validateFieldsNotEmpty() {

    let Component = mapComponentsToSteps[currentStep];
    let errorMessageForComponent = getErrorMessageForComponent(Component);
    if (errorMessageForComponent !== '') {
      setValidationSucceeded({
        isValid: false,
        errorMessages: errorMessageForComponent,
      });
      return {
        isValid: false,
        errorMessages: errorMessageForComponent,
      };
    } else {
      setValidationSucceeded({
        isValid: true,
        errorMessages: [],
      });
      validationErrors[`step${currentStep}`] = [];

      return {
        isValid: true,
        errorMessages: [],
      };
    }
  }


  /**
   * This function is triggered after a user successfully inputs their address
   * details during the initial stage (and clicks the "Volgende" button). Its purpose is to update the local storage 
   * with the user's latest address data. Initially, any address input provided on the
   * homepage is stored in local storage. If a user revises their address during the
   * initial step of the 'aanmeldstraat' process and then refreshes the page, without
   * this function, the local storage would still contain the outdated address details.
   * This function ensures that any changes made to the address during the 'aanmeldstraat'
   * step are immediately captured by removing the existing address from local storage 
   * and saving the updated address data. Consequently, if the page is refreshed, 
   * it will reflect the most current address details as entered in the 'aanmeldstraat'.
   */
  function setAddressInLocalStorage() {
    // Clears the previous address information from local storage.
    localStorage.removeItem('addressInformation');
    // Compiles the new address information from the input fields.

    var addressInformation = {
      available_meters: availableMeterTypes,
      streetName: streetName,
      city: cityName,
      postcode: postcode,
      housenumber: housenumber,
      suffix: housenumberSuffix,
      suffixList: houseNumberSuffixesOnAddress
    };
    // Stores the updated address information into local storage.
    localStorage.setItem('addressInformation', JSON.stringify(addressInformation));
  }

  /**
   * @function onNextClick - Handle the next button click
   * @description This function is called when the next button is clicked. It validates the fields and shows the next step if the validation succeeds.
   */
  function onNextClick() {
    const errorMessagesForComponent = getErrorMessageForComponent(mapComponentsToSteps[currentStep]);
    const isValid = errorMessagesForComponent.every(item => Array.isArray(item) && item.length === 0);
    setValidationSucceeded({
      isValid: isValid,
      errorMessages: errorMessagesForComponent,
    });

    if (isValid) {
      if (currentStep === 0) {
        setAddressInLocalStorage();
      }

      let nextStep = currentStep + 1;
      sendToDataLayer(currentStep);


      // special case when transitioning from step 0 based on `isRodaJCAction`. We skip the entiteit step if we are on the roda jc action.
      if (currentStep === 0 && isRodaJCAction()) {
        nextStep = 2;
      }

      // Special case when transitioning from step 8 based on `returnsEnergy`
      if (currentStep === 9) {
        if (returnsEnergy) {
          nextStep = 10; // Proceed to return energy input if energy is returned
        } else {
          nextStep = 11; // Skip to package selection if no energy is returned
        }
      } else if (currentStep === 10) {
        nextStep = 11; // Always move to the package selection after energy return input
      }
      if (currentStep === 3 && (Object.keys(multipleEanCodesForProducts).length !== 0 || !anyRelevantMultipleEanCodes)) {
        nextStep = 8;
      }


      // // Special case when transitioning from step 4 based on `verbruikEstimaterRequired`
      // if (currentStep === 5 && !verbruikEstimaterRequired) {
      //   nextStep = 8;
      // }

      // Clear the error messages for the current step if validation passes
      setValidationErrors(prevState => ({
        ...prevState,
        [`step${currentStep}`]: [],
      }));

      // Add the current step to the step history
      setCurrentStep(nextStep);
    } else {
      // If validation fails, set the errors for the current step
      setValidationErrors(prevState => ({
        ...prevState,
        [`step${currentStep}`]: errorMessagesForComponent,
      }));
    }
  }

  const hasNonEmptyErrors = (errors) => {
    return errors.some(error => Array.isArray(error) ? error.length > 0 : error);
  };


  /**
   * Sends data to DataLayer. The current step determines which data is sent.
   * @param {*} currentStep 
   */
  function sendToDataLayer(currentStep) {

    var stepEventMappings = {
      0: "postcodeIngevuld",
      1: "zakelijk_of_particulier",
      2: "energieproduct",
      4: "dubbele_meter",
      5: "energieverbruik",
      7: "pand",
      8: "verbruik_ingevuld",
      9: "stroom_opwekken",
      10: "terug_leveren",
      11: "onze_aanbieding",
      12: "persoonsgegevens",
      13: "contact_gegevens",
      14: "gegevens_overzicht"
    };
    var eventMapping = stepEventMappings[currentStep];
    if (eventMapping !== undefined) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': stepEventMappings[currentStep]
      });
    }
  };


  /**
   * @function onPrevClick - Handle the previous button click
   * @description This function is called when the previous button is clicked. It resets the validation state and shows the previous step.
   * @param {*} event
   */
  function onPrevClick(event) {
    event.preventDefault();

    // Clear the specific error message for the current step
    setValidationErrors(prevState => ({
      ...prevState,
      [`step${currentStep}`]: []
    }));

    // Reset the validation succeeded state
    setValidationSucceeded({
      isValid: true,
      errorMessages: [],
    });

    // //Step 4 is the step where we ask for extra options, such as smart meter. But we currently don't ask for any extra options, so skip it.




    // If we're on step 6 and 'entiteit' is 'Zakelijk', go back to step 4
    if (currentStep === 7 && entiteit === "Zakelijk") {
      setCurrentStep(5);
    }

        // if we're on step 2 and is roda jc action, go back to step 0 (skip the entiteit step)
    else if (currentStep === 2 && isRodaJCAction()) {
          setCurrentStep(0);
    }

    else if (currentStep === 8) {
      setCurrentStep(2);
    }

    else if (currentStep === 4 && (Object.keys(multipleEanCodesForProducts).length == 0 || !anyRelevantMultipleEanCodes)) {
      // go back to step 2 instead of 3, otherwise we just get redirected back to step 4 again
      setCurrentStep(2);
    }

    else if (currentStep === 5) {
      setCurrentStep(2);
    }

    // Special handling for moving back from step 10 to step 8 or 9 based on `returnsEnergy`
    else if (currentStep === 11) {
      // We don't ask the user if they return energy anymore, so set current step to 8.
      // setCurrentStep(returnsEnergy ? 10 : 8);
      setCurrentStep(8);
    }
    // Special handling for moving back from step 7 to step 4 if `verbruikEstimaterRequired` is false
    else if (currentStep === 8 && !verbruikEstimaterRequired) {
      setCurrentStep(5);
    }


    // If chosen product doesn't include electricty, then there is no need to ask for eletricic-specific extra options.
    else if (currentStep === 5 && !chosenProduct.includes("Electriciteit")) {
      setCurrentStep(2);
    }

    // Special handling for moving back from steps 9 to step 8 directly if `returnsEnergy` is false
    else if (currentStep === 10) {
      setCurrentStep(9);
    }

    else {
      // Default behavior for other steps
      setCurrentStep(currentStep - 1);
    }
  }




  /**
   * @function renderStep - Render the current step
   * @description This function renders the current step.
   * @returns
   */
  const renderStep = () => {

    const spinner = isFetchingData && (
      <div className="spinner-container">
        <CircularProgress className="data-fetch-spinner" />
      </div>
    );


    switch (currentStep) {
      case 0:
        return (
          <div className="AdresKiezer">
            {spinner}
            <AdresKiezer
              setIsFetchingData={setIsFetchingData}
              postcode={postcode}
              housenumber={housenumber}
              suffix={housenumberSuffix}
              setPostcode={setPostcode}
              setHousenumber={setHousenumber}
              onValidationChange={setValidationSucceeded}
              isPostCodeAndHouseNumberFormatValid={isPostCodeAndHouseNumberFormatValid}
              setIsPostCodeAndHouseNumberFormatValid={setIsPostCodeAndHouseNumberFormatValid}
              setAvailableMeterTypes={setAvailableMeterTypes}
              housenumberSuffixList={housenumberSuffixList}
              setHousenumberSuffixList={setHousenumberSuffixList}
              setHousenumberSuffix={setHousenumberSuffix}
              sethouseNumberSuffixesOnAddress={sethouseNumberSuffixesOnAddress}
              streetName={streetName}
              setStreetName={setStreetName}
              setCityName={setCityName}
              cityName={cityName}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step0", errors)}


            />
          </div>
        );
      case 1:
        return (
          <div className="EntiteitKiezer">
            {spinner}
            <EntiteitKiezer entiteit={entiteit} setChosenEntiteit={setEntiteit} setBedrijfsnaam={setBedrijfsnaam} setKvkNummer={setKvkNummer} agentConfig={agentConfig} />
          </div>
        );

      case 2:
        return (
          <div>
            {spinner}
            <ProductKiezer
              previousChosenProduct={chosenProduct}
              setChosenProduct={setChosenProduct}
              availableMeterTypes={availableMeterTypes}
              postcode={postcode}
              housenumber={housenumber}
              suffix={housenumberSuffix}
              streetName={streetName}
              cityName={cityName}
              setMultipleEanCodesForProducts={setMultipleEanCodesForProducts}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step2", errors)}
            />
          </div>

        );


      case 3:
        // Only continue with this step if the actual chosen product has multiple EAN codes.
        let metersToDisplay = {
          RequiredGasMeterEAN: chosenProduct.includes('Gas') ? multipleEanCodesForProducts.Gas || [] : [],
          RequiredStroomMeterEAN: chosenProduct.includes('Electriciteit') ? multipleEanCodesForProducts.ELK || [] : []
        };
        if (Object.values(metersToDisplay).some(arr => arr.length !== 0)) {
          return (
            <div class="MultipleEanSelection">
              {spinner}
              <MultipleEanSelection
                chosenProduct={chosenProduct}
                postcode={postcode}
                huisnummer={housenumber}
                housenumberSuffix={housenumberSuffix}
                streetName={streetName}
                cityName={cityName}
                selectedEan={selectedEan}
                multipleEanCodesForProducts={multipleEanCodesForProducts}
                setSelectedEan={setSelectedEan}
                setAnyRelevantMultipleEanCodes={setAnyRelevantMultipleEanCodes}
                onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step3", errors)}

              >
              </MultipleEanSelection>
            </div>
          )
        } else {
          // No relevant multiple EAN codes, skip this step
          setAnyRelevantMultipleEanCodes(false);
          setCurrentStep(8);
        }

      case 8:
        return (
          <div class="VerbruikInput">
            {spinner}
            <VerbruikInput
              chosenProduct={chosenProduct}
              dubbeleMeter={dubbeleMeter}
              setDubbeleMeter={setDubbeleMeter}
              returnsEnergy={returnsEnergy}
              returnedEnergyAmount={returnedEnergyAmount}
              setReturnsEnergy={setReturnsEnergy}
              setReturnedEnergyAmount={setReturnedEnergyAmount}
              verbruikEstimaterStep2Output={verbruikEstimaterStep2Output}
              setVerbruikEstimaterStep2Output={setVerbruikEstimaterStep2Output}
              selectedBuildingType={selectedBuildingType}
              setSelectedBuildingType={setSelectedBuildingType}
              entiteit={entiteit}
              householdSize={householdSize}
              sethouseholdSize={setHouseholdSize}
              finalChosenUsage={finalChosenUsage}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step8", errors)}
              setFinalChosenUsage={setFinalChosenUsage}
              solarPanels={solarPanels}
              setSolarPanels={setSolarPanels}
              setIsFetchingData={setIsFetchingData}
              returnsAvailableForAgent={agentConfig.returnsAvailableForAgent}
              agentID={agentConfig.agentId}
              
            />          </div>
        );
      case 9:
        // We no longer ask the user whether they will return energy, so skip this step as well as the next one 
        setCurrentStep(11);
      // const includesElectricity = chosenProduct.includes("Electriciteit");
      // if (includesElectricity) {
      //   return (
      //     <div class="SelfStroomOpwekking">
      //       <SelfStroomOpwekking
      //         returnsEnergy={returnsEnergy}
      //         setReturnsEnergy={setReturnsEnergy}
      //         setReturnedEnergyAmount={setReturnedEnergyAmount}
      //       />
      //     </div>
      //   )
      // } else {
      //   // No electricity, so no need to ask about returning energy
      //   setCurrentStep(11);
      //   return null;
      // }

      // case 10:
      //   if (returnsEnergy) {
      //     return (
      //       <div class="TerugLeveringInput">
      //         <TerugleveringInput
      //           returnedEnergyAmount={returnedEnergyAmount}
      //           setReturnedEnergyAmount={setReturnedEnergyAmount}
      //           dubbeleMeter={dubbeleMeter}
      //         />
      //       </div>
      //     );
      //   }
      case 11:

      
        return (
          <div class="PakketKiezer">
            {spinner}
            <PakketKiezer
              address={{ postcode: postcode, housenumber: housenumber, housenumberSuffix: housenumberSuffix }}
              dubbeleMeter={dubbeleMeter}
              chosenProduct={chosenProduct}
              chosenUsage={finalChosenUsage}
              returnedEnergyAmount={returnedEnergyAmount}
              returnsEnergy={returnsEnergy}
              chosenEntity={entiteit}
              setIsFetchingData={setIsFetchingData}
              setChosenPakket={setChosenPakket}
              chosenPakket={chosenPakket}
              agentID={agentConfig.agentId}
              returnsAvailableForAgent={agentConfig.returnsAvailableForAgent}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step11", errors)}
            />
          </div>
        );
      case 12:
        return (
          <div class="PersoonsGegevens">
            {spinner}
            <PersoonsGegevens
              geslacht={geslacht}
              chosenPakket={chosenPakket}
              setGeslacht={setGeslacht}
              voornaam={voornaam}
              setVoornaam={setVoornaam}
              achternaam={achternaam}
              setAchternaam={setAchternaam}
              geboorteDatum={geboorteDatum}
              setGeboorteDatum={setGeboorteDatum}
              zakelijk={entiteit}
              kvkNummer={kvkNummer}
              setKvkNummer={setKvkNummer}
              bedrijfsnaam={bedrijfsNaam}
              setBedrijfsnaam={setBedrijfsnaam}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step12", errors)}
            />
          </div>
        )
      case 13:
        return (
          <div class="ContactGegevens">
            {spinner}
            <ContactGegevens
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step13", errors)}
              telefoonnummer={telefoonnummer}
              setTelefoonnummer={setTelefoonnummer}
              email={email}
              setEmail={setEmail}

            />
          </div>
        )
      case 14:
        return (
          <div class="BestellingOverzicht">
            {spinner}
            <BestellingOverzicht
              telefoonnummer={telefoonnummer}
              email={email}
              voornaam={voornaam}
              achternaam={achternaam}
              geboorteDatum={geboorteDatum}
              streetName={streetName}
              cityName={cityName}
              postcode={postcode}
              huisnummer={housenumber}
              housenumberSuffix={housenumberSuffix}
              chosenPakket={chosenPakket}
              setTermsOfServiceAccepted={setTermsOfServicesAccepted}
              overstapDatum={overstapDatum}
              setOverstapDatum={setOverstapDatum}
              kvkNummer={kvkNummer}
              bedrijfsnaam={bedrijfsNaam}
              betaalmethode={betaalmethode}
              setBetaalmethode={setBetaalmethode}

            />
          </div>
        )
      case 15:
        return (
          <div class="BestellingAanmaken">
            {spinner}
            <BestellingAanmaken
              chosenPakket={chosenPakket}
              chosenProduct={chosenProduct}
              dubbeleMeter={dubbeleMeter}
              geslacht={geslacht}
              warmtepomp={warmtepomp}
              elektrischeAuto={electricCarWithCharger}
              availableMeters={availableMeterTypes}
              voornaam={voornaam}
              achternaam={achternaam}
              email={email}
              telefoonnummer={telefoonnummer}
              geboorteDatum={geboorteDatum}
              chosenUsage={finalChosenUsage}
              returnedEnergyAmount={returnedEnergyAmount}
              chosenEntity={entiteit}
              kvkNummer={kvkNummer}
              bedrijfsnaam={bedrijfsNaam}
              setIsFetchingData={setIsFetchingData}
              overstapDatum={overstapDatum}
              betaalmethode={betaalmethode}
              selectedEan={selectedEan}
              submissionFailed={submissionFailed}
              setSubmissionFailed={setSubmissionFailed}
              submissionFailedWithReasons={submissionFailedWithReasons}
              setSubmissionFailedWithReasons={setSubmissionFailedWithReasons}
              submissionSuccessful={submissionSuccessful}
              setSubmissionSuccessful={setSubmissionSuccessful}
              agentID={agentConfig.agentId}


            />
          </div>
        )
    }
  };
  const isNextDisabled = isFetchingData ||
    (currentStep === 2 && hasNonEmptyErrors(validationErrors.step2)) ||
    (currentStep === 0 && hasNonEmptyErrors(validationErrors.step0)) ||
    (currentStep === 11 && hasNonEmptyErrors(validationErrors.step11)) ||
    (currentStep === 12 && hasNonEmptyErrors(validationErrors.step12));
  // (currentStep === 4 && hasNonEmptyErrors(validationErrors.step4));




  
  const appContent = (
    <div className="main-container">
      <div className="left-content">
        <ExplainerHeader
          steps={steps}
          currentStep={currentStep}
          currentGroup={currentGroup}
          handleGroupStepClick={handleGroupStepClick}
        />
        <div className="aanmeldstraat-container">
          {configError ? ( // Check if there is a config error
            <div className="error-message">
              <p>We ondervinden momenteel problemen met het laden van het aanmeldformulier. Probeer het later opnieuw of neem contact op met onze klantenservice voor ondersteuning.</p>
            </div>
          ) : (
            <>
              {renderStep()} {/* Render the app content if no error */}
              
              {/* Error message container */}
              {validationErrors[`step${currentStep}`] &&
                validationErrors[`step${currentStep}`].length > 0 &&
                validationErrors[`step${currentStep}`].some(error => Array.isArray(error) ? error[1] !== false : true) && (
                  <div className="error-container">
                    <ul>
                      {validationErrors[`step${currentStep}`].map((error, index) => {
                        if (Array.isArray(error)) {
                          return error[1] !== false ? <li key={index}>{error[0]}</li> : null;
                        } else {
                          return <li key={index}>{error}</li>;
                        }
                      })}
                    </ul>
                  </div>
                )
              }
              
              {/* Navigation */}
              <div className="navigation">
                {currentStep > 0 && (currentStep !== 15 || submissionFailedWithReasons) && (
                  <a href="#" onClick={onPrevClick} disabled={isFetchingData}>Vorige</a>
                )}
  
                {currentStep < 14 && (
                  <button className="btn btn-primary" onClick={onNextClick} disabled={isNextDisabled}>Volgende</button>
                )}
                {currentStep === 14 && (
                  <button className="btn btn-primary" onClick={onNextClick} disabled={isFetchingData}>Offerte aanvragen</button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );

  const [isModalOpen, setIsModalOpen] = useState(showAsModal);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOverlayClick = (event) => {
    // Sluit modal alleen als de klik niet binnen de modal-content plaatsvond
    if (event.target.className.includes('modal-overlay')) {
      handleCloseModal();
    }
  };

  return (
    <>
      {isModalOpen ? (
        <CustomPortal rootId="cleanenergy-aanmeldstraat-root">
          <div className="modal-overlay" onClick={handleOverlayClick}>
            <Box className="modal-content">
              <button className="close-button" onClick={handleCloseModal}>X</button>
              {appContent}
            </Box>
          </div>
        </CustomPortal>
      ) : (
        appContent
      )}
    </>
  );
};
document.addEventListener('DOMContentLoaded', () => {
  const rootId = 'cleanenergy-aanmeldstraat-root';
  let rootElement = document.getElementById(rootId);

  if (!rootElement) {
    rootElement = document.createElement('div');
    rootElement.id = rootId;
    document.body.appendChild(rootElement);

    // Render the React app in modal mode
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App showAsModal={true} />);
  } else {
    // Render the React app in normal mode
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App showAsModal={false} />);
  }
});
